import React, { useEffect, useRef, useCallback } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./Map.css";

const Map = ({ initialLocation }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const mapInitialized = useRef(false);
  const locationCache = useRef({});

  // Khởi tạo bản đồ
  const initMap = useCallback(() => {
    if (mapRef.current) return;

    const vietnamBounds = [
      [8.18, 102.14], // Tây Nam
      [23.39, 109.47], // Đông Bắc
    ];

    const map = L.map("map", {
      maxBounds: vietnamBounds,
      maxBoundsViscosity: 1.0,
      minZoom: 5,
    }).setView([16.0471, 108.2062], 6); // Trung tâm Việt Nam (Đà Nẵng)

    mapRef.current = map;

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    markerRef.current = L.marker([16.0471, 108.2062]).addTo(map);
  }, []);

  // Cập nhật bản đồ và marker
  const updateMap = (lat, lon) => {
    if (mapRef.current && markerRef.current) {
      const map = mapRef.current;
      const marker = markerRef.current;
      const latNum = parseFloat(lat);
      const lonNum = parseFloat(lon);

      const vietnamBounds = [
        [8.18, 102.14],
        [23.39, 109.47],
      ];
      if (
        latNum >= vietnamBounds[0][0] &&
        latNum <= vietnamBounds[1][0] &&
        lonNum >= vietnamBounds[0][1] &&
        lonNum <= vietnamBounds[1][1]
      ) {
        map.setView([latNum, lonNum], 13);
        marker.setLatLng([latNum, lonNum]);
      }
    }
  };

  // Tìm kiếm địa điểm
  const fetchLocation = async (query) => {
    if (locationCache.current[query]) {
      if (locationCache.current[query].length > 0) {
        const { lat, lon } = locationCache.current[query][0];
        updateMap(lat, lon);
      }
      return;
    }

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=1&countrycodes=vn&addressdetails=1`
      );
      const data = await response.json();
      locationCache.current[query] = data;
      if (data.length > 0) {
        const { lat, lon } = data[0];
        updateMap(lat, lon);
      }
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  // Khởi tạo bản đồ và xử lý initialLocation
  useEffect(() => {
    if (!mapInitialized.current) {
      initMap();
      mapInitialized.current = true;
    }

    if (initialLocation) {
      fetchLocation(initialLocation); // Cập nhật bản đồ dựa trên initialLocation
    }
  }, [initialLocation, initMap]);

  return (
    <div className="map-component">
      <div id="map" style={{ height: "300px", width: "100%" }}></div>
    </div>
  );
};

export default Map;